export default __webpack_public_path__ + "static/media/serie1000.d4dd496c.jpg";